import api from './api'

export const schoolSubjectsApi = {
  /**
   * Get list of school subjects with pagination
   * @param {Object} params - Query parameters
   * @param {number} params.page - Page number
   * @param {boolean} params.is_active - Filter by active status
   * @returns {Promise} API response with pagination
   */
  async getSchoolSubjects(params = {}) {
    const queryParams = new URLSearchParams()

    if (params.page) {
      queryParams.append('page', params.page)
    }

    if (params.is_active !== null && params.is_active !== undefined) {
      queryParams.append('is_active', params.is_active)
    }

    const queryString = queryParams.toString()
    const url = queryString ? `/school-subjects?${queryString}` : '/school-subjects'

    const response = await api.get(url)
    return response
  },

  /**
   * Get single school subject details
   * @param {number} id - School subject ID
   * @returns {Promise} API response
   */
  async getSchoolSubject(id) {
    const response = await api.get(`/school-subjects/${id}`)
    return response
  },

  /**
   * Create new school subject
   * @param {Object} subjectData - School subject data
   * @param {string} subjectData.name - Subject name
   * @param {boolean} subjectData.is_active - Subject active status
   * @returns {Promise} API response
   */
  async createSchoolSubject(subjectData) {
    const response = await api.post('/school-subjects', subjectData)
    return response
  },

  /**
   * Update existing school subject
   * @param {number} id - School subject ID
   * @param {Object} subjectData - Updated subject data
   * @returns {Promise} API response
   */
  async updateSchoolSubject(id, subjectData) {
    const response = await api.put(`/school-subjects/${id}`, subjectData)
    return response
  },

  /**
   * Delete school subject
   * @param {number} id - School subject ID
   * @returns {Promise} API response
   */
  async deleteSchoolSubject(id) {
    const response = await api.delete(`/school-subjects/${id}`)
    return response
  }
}
